/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { useEffect, useState } from "react";
import { Grid, Typography, makeStyles, IconButton } from "@material-ui/core";
import { Done, Clear } from "@material-ui/icons";
import { InputField, BoxContainer } from "../FormFields";
import Actions from "../../../fluid/Actions/ActionFactory";
import axios from "axios";
import SnackBar from "../../Snackbar/index";
import ErrorMessageAlert from "../../Utilities/ErrorMessageAlert";

import SecureWrapper from "../../Security/SecureWrapper";

const useStyles = makeStyles(() => ({
  mainContainer: {
    padding: "20px",
    height: "calc(100vh - 95px)",
    overflow: "hidden",
  },
  topContainer: {
    background: "#FFFFFF",
    padding: "20px",
    margin: "10px 0px",
    boxShadow: "0px 3px 6px #00000029",
    height: "50%",
  },
  headerField: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px",
  },
  titleText: {
    color: "#222222",
    fontSize: "18px",
    fontWeight: "bold",
  },
  boxWrapper: {
    height: "48%",
  },
  filedBox: {
    width: "49%",
    height: "100%",
  },
  formField: {
    width: "49%",
  },
}));

const user = {
  name: "",
  email: "",
  password: "",
  confirmPassword: "",
  description: "",
  groups: [],
  user_roles: [],
};

const CreateUser = ({
  setIsNew,
  setIsTableUpdated,
  setisCreate,
  setnewdata,
}) => {
  const classes = useStyles();
  const [userData, setUserData] = useState(user);
  const [groupsList, setGroupsList] = useState([]);
  const [message, setmessage] = useState("");
  const [count, setCount] = useState(false);
  const [error, seterror] = useState(false);
  const [errmsg, seterrmsg] = useState(null);
  const [disable, setdisable] = useState(false);
  const [showPassword, setshowPassword] = useState(false);
  const [confirmPassword, setconfirmPassword] = useState(false);

  const handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    setUserData({ ...userData, [name]: value });
    if (name === "email") {
      setnewdata(value);
    }
  };

  const handleSubmit = () => {
    if (
      userData.password === userData.confirmPassword &&
      userData.email !== ""
    ) {
      const userObj = userData;
      userObj["groups"] = groupsList.map((group) => {
        return {
          name: group.name,
        };
      });
      delete userObj["confirmPassword"];
      console.log("user...", userObj);

      Actions("http_request", {
        url: "/sainapse/sign_up",
        method: "post",
        data: userObj,
      })
        .then((res) => {
          // console.log("res..1", res.data);
          setIsTableUpdated(true);
          setUserData(user);
          setGroupsList([]);
          setIsNew(false);
          setisCreate(true);
          setCount(false);
          setUserData({ ...userData, password: "" });
        })
        .catch((err) => {
          console.log("err..", err.message);
          seterror(true);
          seterrmsg(err);
          setUserData({ ...userData, password: "" });
        });
    } else {
      setCount(true);
      if (userData.email === "") {
        setmessage("Please enter Email in Input Field");
      } else {
        setmessage("Password must be same");
      }
    }
  };
  const onClose = () => {
    setCount(false);
  };
  const closeError = () => {
    seterror(false);
    seterrmsg(null);
  };
  useEffect(() => {
    if (
      userData.name !== "" &&
      userData.email !== "" &&
      userData.password !== "" &&
      userData.confirmPassword !== ""
    ) {
      setdisable(false);
    } else {
      setdisable(true);
    }
    if (userData.password !== userData.confirmPassword) {
      setdisable(true);
    }
    if (
      userData.email &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(userData.email)
    ) {
      setdisable(true);
    }
  }, [userData]);
  return (
    <Grid container className={classes.mainContainer}>
      <Grid container className={classes.topContainer}>
        <Grid item className={classes.headerField}>
          <div>
            <Typography className={classes.titleText}>New User</Typography>
          </div>
          <div>
          <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/sign_up",
                        method : "POST",
                        operands : []
                      }}
                  >
              <IconButton
                onClick={handleSubmit}
                style={{
                  color: disable ? "#62666e" : "#0CD02A",
                }}
                disabled={disable}
              >
                <Done />
              </IconButton>
            </SecureWrapper>
            <IconButton
              style={{
                color: "#FF0000",
              }}
              onClick={() => setIsNew(false)}
            >
              <Clear />
            </IconButton>
          </div>
        </Grid>
        <Grid container justifyContent="space-between">
          <Grid item className={classes.formField}>
            <InputField
              name="name"
              size="small"
              placeholder="Name"
              autoComplete="off"
              value={userData.name}
              onChange={handleChange}
              fullWidth
              required
              helperText={
                userData.name === "" ? "* This Field is Required " : ""
              }
              error={userData.name === "" ? true : false}
            />
          </Grid>
          <Grid item className={classes.formField}>
            <InputField
              name="email"
              size="small"
              placeholder="Email"
              autoComplete="off"
              value={userData.email}
              onChange={handleChange}
              fullWidth
              helperText={
                userData.email === ""
                  ? "* This Field is Required "
                  : userData.email &&
                    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                      userData.email
                    )
                  ? "* Please Enter Valid Email id"
                  : ""
              }
              error={
                userData.email === "" ||
                (userData.email &&
                  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                    userData.email
                  ))
                  ? true
                  : false
              }
            />
          </Grid>
        </Grid>
        <Grid container justifyContent="space-between">
          <Grid item className={classes.formField}>
            <InputField
              name="password"
              size="small"
              placeholder="Enter Password"
              type={showPassword ? "text" : "password"}
              autoComplete="new-password"
              value={userData.password}
              onChange={handleChange}
              showPassword={showPassword}
              setshowPassword={setshowPassword}
              fullWidth
              helperText={
                userData.password === "" ? "* This Field is Required " : ""
              }
              error={userData.password === "" ? true : false}
            />
          </Grid>
          <Grid item className={classes.formField}>
            <InputField
              name="confirmPassword"
              size="small"
              placeholder="Repeat Password"
              type={confirmPassword ? "text" : "password"}
              autoComplete="off"
              value={userData.confirmPassword ? userData.confirmPassword : ""}
              onChange={handleChange}
              confirmPassword={confirmPassword}
              setconfirmPassword={setconfirmPassword}
              fullWidth
              helperText={
                userData.confirmPassword === ""
                  ? "* This Field is Required "
                  : userData.password !== userData.confirmPassword
                  ? "* Password must be same"
                  : ""
              }
              error={
                userData.confirmPassword === "" ||
                userData.password !== userData.confirmPassword
                  ? true
                  : false
              }
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <InputField
            name="description"
            size="large"
            placeholder="Description"
            value={userData.description}
            onChange={handleChange}
            fullWidth
            multiline
            rows={6}
          />
        </Grid>
      </Grid>
      <Grid
        container
        style={{ display: "flex", justifyContent: "space-between" }}
        className={classes.boxWrapper}
      >
        <Grid item className={classes.filedBox}>
          <BoxContainer
            userType="new"
            title="Groups"
            leftBox={groupsList}
            setLeftBox={setGroupsList}
          />
        </Grid>
      </Grid>
      {count && (
        <SnackBar
          openDialog={count}
          message={message}
          onclose={onClose}
          severity={"error"}
        />
      )}
      {error && (
        <ErrorMessageAlert
          open={error}
          handleClose={closeError}
          errorInfo={errmsg}
        />
      )}
    </Grid>
  );
};

export default CreateUser;
